import React, {useEffect} from 'react';
import {NavigationProps} from "../constants/Props";
import Screen from "../components/Screen";
import Title from "../components/Title";
import TextInput from "../components/TextInput";
import Box from "../components/Box";
import {IAuthStore} from "../stores/AuthStore";
import {observer} from "mobx-react";
import {toI18N} from "../utils/I18n";
import {usePrevious} from "../utils/HooksHelper";
import * as Analytics from "../utils/Analytics";


interface Props extends NavigationProps {
    store: IAuthStore;
}

function EmailScreen(props: Props) {
    const {onNext, onBack, store: {email, setEmail},
        isActive,
    } = props;

    const prevIsActive = usePrevious(isActive);
    useEffect(() => {
        if (!prevIsActive && isActive) {
            Analytics.logEvent(Analytics.events.land_on_input_email_page);
        }
    });


    return (
        <Screen
            title={"email_screen_header_title"}
            subtitle={"email_screen_header_subtitle"}
            onBack={onBack}
            onNext={onNext}
            disabledNext={!props.store.emailCanProceed}>

            <Box center topMargin={116}>
                <Title shrink title={toI18N("enter_email_title")}
                       subtitle={toI18N("enter_email_subtitle")}/>
            </Box>

            <Box grow top sideMargin topMargin={54}>
                <TextInput
                    inputMode={"email"}
                    autoCapitalize={'off'}
                    autoCorrect={'off'}
                    value={email}
                    onChange={setEmail}
                    placeholder={toI18N("enter_email_input_placeholder")}
                    id={"email-input-email-screen"}/>
            </Box>

        </Screen>
    );
}

export default observer(EmailScreen);
